module.exports = __webpack_public_path__ + "img/FingrPrint.3073577f.png";